import { type HTTPURL, isHTTPURL } from "@bracket/types";

/**
 * Extracts the Morpho market ID from a given Morpho URL.
 *
 * @param {object} props
 * @param {string} props.url - The full Morpho URL string to extract from
 * @returns {Promise<string>} Resolves to the market ID string.
 * @throws Will throw an error if the URL does not contain a 'market' segment followed by an ID.
 */
	export const getMorphoIdFromURL = ( url: HTTPURL, ): string|null => {
		try {
			if(!url) return null;
			if(!isHTTPURL(url)) {
				throw new Error("Invalid Morpho URL: not a HTTP URL");
			}
			const segments = url.split("/");
			const marketIndex = segments.indexOf("market");
			if(marketIndex === -1 || marketIndex + 1 >= segments.length) {
				throw new Error("Invalid Morpho URL: 'market' segment not found or no ID after market");
			}
			return segments[marketIndex + 1];
	} catch(err) {
		console.warn(`Invalid Morpho URL: ${err instanceof Error ? err.message : "unknown error"}`);
		return null;
	}
}
